// Swedish

export default {
  newVersionAvailable: 'Ny version tillgänglig',
  versionInfo: 'En ny version av {appName} är tillgänglig. Vänligen ladda om sidan för att uppdatera till version {version}.',
  reload: 'Ladda om',
  later: 'Senare',
};
